import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=40e7cc3e&lang=pug&"
import script from "./PlayersList.vue?vue&type=script&lang=js&"
export * from "./PlayersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports